import React, { useEffect, useState } from "react";
import { useQueryState } from "nuqs";
import TabsContain from "../../../views/components/reuseComp/TabsContain";
import AuthorListingSection from "./author/author";
import BlogListingSection from "./blogs/Blog";
import { useAuthorList } from "../../../hooks/api/author/hook";
import { useListBlog } from "../../../hooks/api/blog/hook";
import Banner from "../../components/sections/Banner"
import { usePageDetail, usePageSave } from "../../../hooks/api/pages/hooks"
import { Form, message } from "antd";
import { IBlogPage, IPagePayload } from "@src/types/api/pages";
import { getSingleImageUrl } from "../../../lib/utils"

const AuthorBlogTabs: React.FC<{ setBreadcrumb: (b: string) => void }> = ({
  setBreadcrumb,
}) => {
  const [tab, setTab] = useQueryState("tab");
  const activeTab = tab || "Author";

  const { data } = usePageDetail("BLOG");
  const [pageData, setPageData] = useState<any>(null);

  const [isEditing, setIsEditing] = useState(false);

  const { data: authorAllData, refetch: refetchAuthors } = useAuthorList(
    { page: 1, limit: 20 },
    { staleTime: 0 },
  );
  const authors = authorAllData?.data || [];

  const { refetch: refetchBlogs } = useListBlog(
    { page: 1, limit: 20 },
    { staleTime: 0 },
  );

  const { mutate: updateService, isPending } = usePageSave({});

  useEffect(() => {
    if (data?.data) setPageData(data.data);
  }, [data]);

  const sections = ["Banner"];
  const [form] = Form.useForm();

  const handleCancel = () => {
    setIsEditing(false);
    form.resetFields();
  };

  const handleSave = async () => {
    try {
      const values = await form.validateFields();

      const payload: IBlogPage = {
        _id: pageData?._id,
        pageType: "BLOG",

        banner:
          activeTab === "Banner"
            ? {
                heading: values?.banner?.heading || "",
                image: getSingleImageUrl(values?.banner?.image),
              }
            : pageData?.banner,
      };

      updateService(payload, {
        onSuccess: (res) => {
          message.success("Page updated successfully");
          setPageData(res.data);
          setIsEditing(false);
        },
        onError: () => {
          message.error("Failed to update page");
        },
      });
    } catch (error) {
      console.log("❌ Validation failed:", error);
    }
  };

  const handleChangeTab = (section: string) => {
    setTab(section);
    setBreadcrumb(section);
    if (section === "Blog") {
      refetchBlogs();
      refetchAuthors();
    }
    if (section === "Author") refetchAuthors();
  };

  return (
    <div>
      <TabsContain
        sections={["Banner", "Author", "Blog"]}
        activeTab={activeTab}
        handleChangeTab={handleChangeTab}
      />
      {activeTab === "Banner" && (
        <Banner
          isEditing={isEditing}
          setIsEditing={setIsEditing}
          handleCancel={handleCancel}
          handleSave={handleSave}
          bannerData={pageData?.banner}
          loading={isPending}
          form={form}
        />
      )}

      {activeTab === "Author" && (
        <AuthorListingSection refetch={refetchAuthors} />
      )}

      {activeTab === "Blog" && (
        <BlogListingSection
          refetch={refetchBlogs}
          authors={authors}
          refetchAuthors={refetchAuthors}
        />
      )}
    </div>
  );
};
export default AuthorBlogTabs;
